(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.product-buybox');
  roots.forEach(function (root) {
    if (!root || root.dataset.pbbInit) return;
    root.dataset.pbbInit = 'true';

    var tiers = root.querySelectorAll('[data-pbb-tier]');
    tiers.forEach(function (tier) {
      var radio = tier.querySelector('.pbb-tier-radio');
      radio.addEventListener('change', function () {
        tiers.forEach(function (t) { t.classList.remove('pbb-tier--selected'); });
        tier.classList.add('pbb-tier--selected');
      });
    });

    var thumbs = root.querySelectorAll('[data-pbb-thumb]');
    var mainImage = root.querySelector('[id^="pbb-main-image-"]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage) mainImage.src = thumb.dataset.src;
      });
    });

    var addBtn = root.querySelector('[data-pbb-add-to-cart]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var selectedTier = root.querySelector('[data-pbb-tier] .pbb-tier-radio:checked');
        var quantity = 1;
        if (selectedTier) {
          quantity = parseInt(selectedTier.closest('[data-pbb-tier]').dataset.quantity, 10) || 1;
        }
        var variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          });
      });
    }

    var viewerEl = root.querySelector('[data-pbb-viewer-count]');
    if (viewerEl) {
      var currentViewers = Math.floor(Math.random() * 41) + 70;
      var maxViewers = 180;
      viewerEl.textContent = currentViewers;
      setInterval(function () {
        currentViewers += Math.floor(Math.random() * 5) + 1;
        if (currentViewers > maxViewers) {
          currentViewers = Math.floor(Math.random() * 11) + 165;
        }
        viewerEl.textContent = currentViewers;
      }, 10000);
    }

    var dateEl = root.querySelector('[data-pbb-shipping-date]');
    if (dateEl) {
      var giorni = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
      var mesi = ['gen.', 'feb.', 'mar.', 'apr.', 'mag.', 'giu.', 'lug.', 'ago.', 'set.', 'ott.', 'nov.', 'dic.'];
      var domani = new Date();
      domani.setDate(domani.getDate() + 1);
      dateEl.textContent = giorni[domani.getDay()] + ' ' + domani.getDate() + ' ' + mesi[domani.getMonth()];
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wraps = document.querySelectorAll('[data-rc-track-wrap]');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('[data-rc-track]');
    if (!wrap || !track || wrap.dataset.rcInit) return;
    wrap.dataset.rcInit = 'true';

    track.innerHTML += track.innerHTML;

    var paused = false;
    var speed = parseFloat(wrap.dataset.scrollSpeed) || 0.4;

    function loop() {
      if (!paused) {
        wrap.scrollLeft += speed;
        if (wrap.scrollLeft >= track.scrollWidth / 2) {
          wrap.scrollLeft -= track.scrollWidth / 2;
        }
      }
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    wrap.addEventListener('mouseenter', function () {
      paused = true;
    });
    wrap.addEventListener('mouseleave', function () {
      paused = false;
      isDown = false;
      wrap.classList.remove('is-dragging');
    });

    var isDown = false, startX = 0, startScroll = 0;
    wrap.addEventListener('pointerdown', function (e) {
      isDown = true;
      paused = true;
      startX = e.pageX;
      startScroll = wrap.scrollLeft;
      wrap.classList.add('is-dragging');
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      wrap.scrollLeft = startScroll - (e.pageX - startX);
    });
    window.addEventListener('pointerup', function () {
      isDown = false;
      wrap.classList.remove('is-dragging');
      paused = false;
    });

    var t;
    wrap.addEventListener('touchstart', function () {
      paused = true;
    });
    wrap.addEventListener('touchend', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        paused = false;
      }, 2000);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
